import React from 'react';
import { Route, IndexRoute } from 'react-router';

import CoreLayout from '../layouts/CoreLayout';
import NoSitePage from '../pages/NoSitePage';
import SitePage from '../pages/SitePage';

export default (store, siteCase, isNew = false) => (
  <Route path="/" component={CoreLayout} siteCase={siteCase} isNew={isNew}>
    <IndexRoute component={NoSitePage} />
    <Route path="sites/:id" component={SitePage} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/routes/index.js